import makeStyles from '@mui/styles/makeStyles'

type Props = {
  success: boolean
}

export default makeStyles(theme => ({
  container: {
    '& .MuiPaper-root': {
      padding: 0
    }
  },

  content: {
    border: '0',
    padding: '24px',
    marginTop: '0'
  },

  dialogTitle: {
    height: '30px',
    color: theme.corporate.secondaryColor,
    background: (props: Props) =>
      props.success ? theme.palette.success.main : theme.palette.primary.main,
    padding: '8px 16px',

    '& svg': {
      padding: 0
    }
  },

  lexonIcon: {
    marginRight: theme.spacing(2)
  },

  successBox: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 50px',
    color: theme.corporate.primaryColor
  },
  actions: {
    padding: '8px 20px 20px 0'
  }
}))
